// @mui
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
//
import CasErrorDisplay from '../CasError/CasErrorDisplay';

interface Props {
  message: string;
}

export default function CasTableError({ message }: Props) {
  return (
    <TableRow>
      <TableCell colSpan={12}>
        <CasErrorDisplay message={message.length > 250 ? message.substring(0, 250) : message} />
      </TableCell>
    </TableRow>
  );
}
